const getters = {
  routes: state => state.permissionFuns.routes,
  addRoutes: state => state.permissionFuns.addRoutes,
  searchRouters: state => state.permissionFuns.searchRouters,
  requestLoading: state => state.app.requestLoading,
  size: state => state.app.size,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  loginUserForm: state => state.login.loginUserForm,
  roles: state => state.user.roles,
  funcs: state => state.user.funcs,
  params: state => state.approve.params,
}
export default getters
